import React from 'react';
import { Alert } from 'antd';

const ErrorDisplay = ({ 
  errorCode = 'GENERAL_ERROR', 
  errorMessage = 'An error occurred', 
  type = 'error',
  showIcon = true,
  closable = false,
  onClose,
  className = ''
}) => {
  const getErrorTitle = (code) => {
    const errorTitles = {
      'AUTH_FAILED': 'Authentication Failed',
      'VALIDATION_ERROR': 'Validation Error',
      'NETWORK_ERROR': 'Network Error',
      'SERVER_ERROR': 'Server Error',
      'NOT_FOUND': 'Not Found',
      'PERMISSION_DENIED': 'Permission Denied',
      'GENERAL_ERROR': 'Error'
    };
    return errorTitles[code] || 'Error';
  };

  if (!errorMessage && !errorCode) return null;

  return (
    <Alert
      message={getErrorTitle(errorCode)}
      description={errorMessage}
      type={type}
      showIcon={showIcon}
      closable={closable}
      onClose={onClose}
      className={`${className}`}
      role="alert"
      aria-live="polite"
    />
  );
};

export default ErrorDisplay;
